import { CookieStorage } from 'cookie-storage';

const A_WEEK_FROM_TODAY = new Date(Date.now() + 604800000);
const domain = window.location.hostname
  .split('.')
  .slice(1)
  .join('.') || window.location.hostname;

export const setCookie = (key, value, expires = A_WEEK_FROM_TODAY) => {
  const cookieStorage = new CookieStorage({ expires, path: '/', domain });
  cookieStorage.setItem(key, value);
};
